import { Collapse } from 'antd';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function R() {
    const { useLang, Link, useRouter } = useGlobal();
    const { t } = useLang('offgrid');
    const { locale } = useRouter();
    const lists: any = [
        {
            title: 'secR_q1',
            desc: 'secR_a1',
        },
        {
            title: 'secR_q2',
            desc: 'secR_a2',
        },
        {
            title: 'secR_q3',
            desc: 'secR_a3',
        },
        {
            title: 'secR_q4',
            desc: 'secR_a4',
        },
        {
            title: 'secR_q5',
            desc: 'secR_a5',
        },
    ];

    return (
        <div id="off-grid-R" className={`off-grid-R off-grid-box ${css['off-grid-R']}`}>
            <div className="text-info">
                <h2 className="title">{t('secR_title')}</h2>
            </div>
            <Collapse
                ghost={true}
                className="collapse-lists"
                defaultActiveKey={0}
                // onChange={setActive}
                // accordion={true}
                expandIcon={({ isActive }: any) => {
                    return (
                        <svg
                            className={`collapse-icon ${isActive ? 'active' : ''}`}
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                        >
                            <path d="M17.5 15L12.5 10L7.5 15" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    );
                }}
                expandIconPosition="right"
            >
                {lists?.map((list: any, k: number) => (
                    <Collapse.Panel className="list-title" key={k} header={t(list.title)}>
                        <p className="list-desc">
                            {t.rich(list.desc, {
                                link1: (text: any) => (
                                    <Link className="a-link" href={t(`${list.desc}_link1`)}>
                                        {text}
                                    </Link>
                                ),
                                link2: (text: any) => (
                                    <Link className="a-link" href={t(`${list.desc}_link2`)}>
                                        {text}
                                    </Link>
                                ),
                            })}
                        </p>
                    </Collapse.Panel>
                ))}
            </Collapse>
        </div>
    );
}
